import React, { useContext } from "react";
import { FaWeightHanging, FaArrowUp, FaTape, FaStopCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";
import "../TrainingGlobal.css";
import BannerImage from "./crane.jpg";

const Crane: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);

  const handleBooking = () => {
    if (isAuthenticated) {
      navigate('/booking/crane-safety');
    } else {
      navigate('/login', { state: { from: '/booking/crane-safety' } });
    }
  };

  return (
    <div className="training-page">
      <div className="training-max-width">

        {/* --- HERO --- */}
        <div className="training-hero" style={{ backgroundImage: `url(${BannerImage})` }}>
          <span className="hero-tag">Heavy Lifting</span>
          <h1 className="hero-title">Crane & Rigging Safety</h1>
          <p className="hero-subtitle">
            Moving mountains safely. Load dynamics, signaling, and the critical role of the rigger.
          </p>
          <button onClick={handleBooking} className="btn-hero">
            Book Now <span style={{ fontSize: '1.2em' }}>→</span>
          </button>
        </div>

        {/* --- CONTENT --- */}
        <div className="detail-content">

          <div className="content-article">
            <div className="article-section">
              <h2 className="article-heading">Pre-Lift Planning</h2>
              <p className="article-text">
                Every lift must be planned. Know the weight of the load and the Center of Gravity (CoG).
                Check the crane's load chart—never exceed the Safe Working Load (SWL) for the given radius/boom angle.
                Check ground stability for outriggers.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Rigging Basics</h2>
              <p className="article-text">
                The rigger is responsible for securing the load.
                <br />- Inspect slings (webbing, chain, wire rope) for cuts or kinks.
                <br />- Use padding on sharp corners to protect slings.
                <br />- Ensure the hook safety latch is operational.
                <br />- Never stand under a suspended load.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Communication</h2>
              <p className="article-text">
                The crane operator creates the movement, but the banksman (signaller) directs it.
                Use standard hand signals or radio. <strong>ANYONE</strong> can give the "Emergency Stop" signal.
                For all other signals, the operator obeys only the designated signaller.
              </p>
            </div>
          </div>

          {/* --- SIDEBAR --- */}
          <div className="content-sidebar">
            <div className="sidebar-widget">
              <h4 className="widget-title">Critical Checks</h4>
              <ul className="key-list">
                <li><FaWeightHanging className="check-icon" /> Verify Load Weight</li>
                <li><FaTape className="check-icon" /> Check Sling Condition</li>
                <li><FaArrowUp className="check-icon" /> Test Lift (few inches)</li>
                <li><FaStopCircle className="check-icon" /> Clear Drop Zone</li>
              </ul>
            </div>

            <div className="sidebar-widget" style={{ background: 'linear-gradient(135deg, #111 0%, #222 100%)', border: '1px solid #333' }}>
              <h4 className="widget-title">Lift Safely</h4>
              <p style={{ color: '#ccc', marginBottom: '20px', fontSize: '0.9rem' }}>
                One mistake can be catastrophic. Get certified.
              </p>

              <button
                onClick={handleBooking}
                className="btn-primary"
                style={{ width: '100%', justifyContent: 'center' }}
              >
                Book Now
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Crane;
